import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Dashboard from './pages/Dashboard';
import Stats from './pages/Stats';
import Alerts from './pages/Alerts';
import Login from './pages/Login';
import Signup from './pages/Signup';
import QR from './pages/QR';
import LeaveReview from './pages/LeaveReview';
import PrivacyPolicy from "./pages/legal/PrivacyPolicy";
import CookiesPolicy from "./pages/legal/CookiesPolicy";
import CGU from "./pages/legal/CGU";
import RequestData from "./pages/legal/RequestData";
import PaymentSuccess from './pages/PaymentSuccess'; // <-- add this
import ProtectedRoute from './components/ProtectedRoute';
import './styles/main.scss';
import styles from './App.module.scss';
import InfoFooter from './components/InfoFooter';
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth } from './firebaseConfig';
import ConsentBar from './components/ConsentBar';
import PaymentsBilling from "./pages/legal/PaymentsBilling";

import Directory from './pages/Directory';
import BusinessPublic from './pages/BusinessPublic';
import PublicProfileForm from './pages/PublicProfileForm';
import BusinessProfileFull from './pages/BusinessProfileFull';



function App() {
  const [firebaseUser] = useAuthState(auth);

  useEffect(() => {
    if (firebaseUser) {
      firebaseUser.getIdToken(true).then(token => {
        localStorage.setItem('token', token);
      });
    } else {
      localStorage.removeItem('token');
    }
  }, [firebaseUser]);

  return (
    <Router>
      <div className={styles.appContainer}>
        <Navbar />
        <main className={styles.main}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/dashboard/*" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/stats" element={<ProtectedRoute><Stats /></ProtectedRoute>} />
            <Route path="/alerts" element={<ProtectedRoute><Alerts /></ProtectedRoute>} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/leave-review/:businessId" element={<LeaveReview key={window.location.pathname} />} />
            <Route path="/qr" element={<ProtectedRoute><QR /></ProtectedRoute>} />
            <Route path="/payment-success" element={<PaymentSuccess />} />
            <Route path="/legal/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/legal/cookies-policy" element={<CookiesPolicy />} />
            <Route path="/legal/cgu" element={<CGU />} />
            <Route path="/legal/request-data" element={<RequestData />} />
            <Route path="/legal/payments-billing" element={<PaymentsBilling />} />
            <Route path="/directory" element={<Directory />} />
            <Route path="/directory/:slug" element={<BusinessPublic />} />
            <Route path="/b/:slug" element={<BusinessPublic />} />
<Route path="/p/:slug" element={<BusinessProfileFull />} />

            <Route path="/dashboard/public-profile" element={<ProtectedRoute><PublicProfileForm /></ProtectedRoute>} />

          </Routes>
          <ToastContainer position="top-right" autoClose={3000} theme="colored" />
        </main>
        <InfoFooter />
        <ConsentBar />
      </div>
    </Router>
  );
}

export default App;
